import type { ISpaceAuthLookupResponse } from "@/api/space/dtos/authenticator.dto";
import { isSignedInteger, normalizeStr } from "@/utils/utils";

// ------------------------------- FUNCTIONS -------------------------------
export function encontrarCorrespondenciaExataUsuario(
	textoDigitado: string,
	opcoes: ISpaceAuthLookupResponse[],
): ISpaceAuthLookupResponse | null {
	const texto = (textoDigitado ?? "").trim();
	if (!texto) return null;

	const correspondencias = isSignedInteger(texto)
		? opcoes.filter((usuario) => String(usuario.id_cad_pessoa ?? "") === texto)
		: opcoes.filter((usuario) => normalizeStr(usuario.nome) === normalizeStr(texto));

	return correspondencias.length === 1 ? correspondencias[0] : null;
}
